module.exports = __webpack_public_path__ + "static/media/device-icons.cdeafc44f49d5da64206bcb6e3639e8a68c403eec0e841da895179cd95c86704.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/core/icons/device-icons.ttf
// module id = 2360
// module chunks = 204